.row {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.radioGroup {
  display: inline-flex;
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-sm);
  overflow: hidden;
}

.segment {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-3);
  border: 0;
  background: transparent;
  cursor: pointer;
}

.segmentActive {
  background: var(--tuna-color-accent);
  color: var(--tuna-color-on-accent);
}

.playButton,
.singleButton {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-3);
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-sm);
  background: var(--tuna-color-surface);
  cursor: pointer;
}
